/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { SegmentedControl } from '@radix-ui/themes';

import { useCallback } from 'fierry/react';


const OnValueChange = (selected, options, onChange) =>
{
  const callback = (option) =>
  {
    return String(option.value) === selected;
  };

  onChange?.(options.find(callback).value);
};


export default ({ options, value, onChange, ...props }) =>
{
  const onValueChange = useCallback(OnValueChange, [ options, onChange ]);

  const children = options.map(option =>
  (
    <SegmentedControl.Item key = {option.value} value = {String(option.value)}>{option.label}</SegmentedControl.Item>
  ));

  return <SegmentedControl.Root {...props} value = {String(value)} onValueChange = {onValueChange} children = {children} />;
};
